import { render, staticRenderFns } from "./living.vue?vue&type=template&id=72f9223f&scoped=true"
import script from "./living.vue?vue&type=script&lang=js"
export * from "./living.vue?vue&type=script&lang=js"
import style0 from "./living.vue?vue&type=style&index=0&id=72f9223f&prod&lang=scss&scoped=true"
import style1 from "./living.vue?vue&type=style&index=1&id=72f9223f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9223f",
  null
  
)

export default component.exports